import { Visibility, VisibilityOff } from '@material-ui/icons';

export const OTP_VALIDITY_IN_MINS = 10;

export const OTP_VALIDITY_IN_MS = OTP_VALIDITY_IN_MINS * 60 * 1000;

export const PASSWORD_INPUT_MODE = {
  password: 'password',
  text: 'text',
};

export const FORM_STEP = {
  STEP_1: 'step-1',
  STEP_2: 'step-2',
};

export const MODAL_KEY = {
  CONFIRM_OTP: 'confirm-otp',
};

export const RESPONSE_POPUP_KEY = {
  SEND_OTP: 'send-otp-response',
  CONFIRM_OTP: 'confirm-otp-response',
  RESET_PASSWORD: 'reset-password',
};

export const CONFIRMATION_POPUP_KEY = {
  CONFIRM_OTP: 'confirm-otp-close-confirmation',
};

export const CAPITAL_LETTERS_KEY_CODE = new Set([
  65, // alphabetical keys
]);

export const SMALL_LETTERS_KEY_CODE = new Set([
  97, // alphabetical keys
]);

let capitalLetter = 65;
let smalllLetter = 97;

for (let i = 0; i < 26; i++) {
  CAPITAL_LETTERS_KEY_CODE.add(capitalLetter++);
  SMALL_LETTERS_KEY_CODE.add(smalllLetter++);
}

export const ALPHABETICAL_KEY_CODE = new Set([
  ...CAPITAL_LETTERS_KEY_CODE,
  ...SMALL_LETTERS_KEY_CODE,
]);

export const NUMERIC_KEY_CODE = new Set([
  48, 49, 50, 51, 52, 53, 54, 55, 56, 57, // numeric keys
  96, 97, 98, 99, 100, 101, 102, 103, 104, 105, // numeric keys from numeric keypad
]);

export const DELETE_KEY_CODE = new Set([
  8, 127, // backspace & delete
]);

export const TAB_KEY_CODE = new Set([
  9, // tab
]);

export const SHIFT_KEY_CODE = new Set([
  16, // shift
]);

export const ALLOWED_KEY_CODE = new Set([
  ...ALPHABETICAL_KEY_CODE,
  ...NUMERIC_KEY_CODE,
  ...DELETE_KEY_CODE,
  ...TAB_KEY_CODE,
  ...SHIFT_KEY_CODE,
]);

export const ISentOTP = () => ({
  Alias: '',
  CompanyId: 0,
  IsCodeSent: false,
  PatientPhone: '',
  PeopleId: 0,
  ResponseCode: 0, // -1 is ERROR
  ResponseMessage: '', // The password has been sent to the user's phone number
});

export const IRecoverPassword = () => {
  const _interface = {
    sendOTP: {
      data: ISentOTP(),
      called: false,
      loading: false,
    },
    validateOTP: {
      data: {},
      called: false,
      loading: false,
    },
    resetUsingOTP: {
      data: {},
      called: false,
      loading: false,
    },
  };

  return _interface;
};

export const IRecoveryForm = () => ({
  alias: '',
  username: '',
  peopleId: 0,
  phone: '',
  companyId: 0,
});

export const IOTP = () => ({
  digit1: '',
  digit2: '',
  digit3: '',
  digit4: '',
  digit5: '',
  digit6: '',
});

export const IPasswordForm = () => ({
  companyId: 0,
  peopleId: 0,
  username: '',
  uniqueCode: '',
  password: '',
  passwordConfirm: '',
});

export const IPasswordMode = () => new Map([
  [PASSWORD_INPUT_MODE.password, {
    type: PASSWORD_INPUT_MODE.password,
    Icon: VisibilityOff,
    nextType: PASSWORD_INPUT_MODE.text,
  }],
  [PASSWORD_INPUT_MODE.text, {
    type: PASSWORD_INPUT_MODE.text,
    Icon: Visibility,
    nextType: PASSWORD_INPUT_MODE.password,
  }],
]);

export const IPasswordVisibilityOption = () => {
  const _interface = new Map([
    ['password', PASSWORD_INPUT_MODE.password],
    ['passwordConfirm', PASSWORD_INPUT_MODE.password],
  ]);

  return _interface;
};

export const IHistory = () => ({
  push: () => {},
});
